'use client'

import {Checkbox as CheckboxPrimitive} from '@base-ui/react/checkbox'

import {cn} from '@/lib/utils'
import {CheckIcon} from 'lucide-react'

function Checkbox({
  className,
  id,
  render,
  'aria-label': ariaLabel,
  ...props
}: CheckboxPrimitive.Root.Props) {
  // base-ui forwards `class` and `data-*` to the render slot but not arbitrary
  // ARIA attributes — without this, Lighthouse's `aria-toggle-field-name`
  // fails because the role=checkbox span has no accessible name.
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      id={id}
      aria-label={ariaLabel}
      render={
        render ??
        (id || ariaLabel ? (
          <span id={id ? `${id}-control` : undefined} aria-label={ariaLabel} />
        ) : undefined)
      }
      className={cn(
        'peer relative flex size-4 shrink-0 items-center justify-center rounded-[4px] border border-foreground/40 transition-colors outline-none group-has-disabled/field:opacity-50 after:absolute after:-inset-x-3 after:-inset-y-2 focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 aria-invalid:aria-checked:border-primary dark:bg-input/30 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 data-checked:border-primary data-checked:bg-primary data-checked:text-primary-foreground dark:data-checked:bg-primary',
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="grid place-content-center text-current transition-none [&>svg]:size-3.5"
      >
        <CheckIcon />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}

export {Checkbox}
